import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordDrawerComponent } from './change-password-drawer.component';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormModule } from '../../../modules/form/form.module';

@NgModule({
  declarations: [
    ChangePasswordDrawerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormModule,
  ],
  exports: [
    ChangePasswordDrawerComponent
  ]
})
export class ChangePasswordDrawerModule { }
